import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

class LoadingPage extends React.Component {  
    render() {
        return (
            <div className='ml-5 mr-5'>
                <div className='flex h-24rem align-items-center flex-column pt-5 pb-5'>
                    <ProgressSpinner style={{width: '200px', height: '200px'}}/>
                    <h3 className='text-700 line-height-3'>Probíhá načítání dat...</h3>
                </div>
            </div>
        );   
    }
}

export default LoadingPage;
